/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Address } from './Address';
import { OrderRequestItem } from './OrderRequestItem';
export interface OrderRequest {
    /**
     * stripe token
     */
    token?: string;

    /**
     * account id to charge
     */
    accountId?: string;

    /**
     * amount (for checks only)
     */
    amount?: number;

    /**
     * check number
     */
    checkNumber?: string;

    /**
     * whether to create/update the stripe customer record with this card
     */
    updateStripeCustomer?: boolean;

    /**
     * entity id
     */
    entityId?: string;

    /**
     * whether to charge the stripe customer on file
     */
    chargeStripeCustomer?: boolean;

    /**
     * billing address
     */
    billingAddress?: Address;

    /**
     * shipping address
     */
    shippingAddress?: Address;

    /**
     * items to purchase
     */
    items?: Array<OrderRequestItem>;

    /**
     * entity type
     */
    entityType?: OrderRequest.EntityType;

}

export namespace OrderRequest {

    export enum EntityType {
            MEMBER = <any> 'MEMBER',
            USER = <any> 'USER',
            ORG = <any> 'ORG',
            PHOTO = <any> 'PHOTO'
    }
}



// WEBPACK FOOTER //
// ./src/common/api/models/OrderRequest.ts